import React, { useState } from "react";
import "./SelectButton.scss";

const SelectButton = ({
  options = [], // Array of options to display. Each option: { label: string, value: any }
  name = "", // Name for radio inputs, required for form usage
  value, // Controlled value (if using controlled component pattern)
  onChange, // Callback function to call when selection changes
  defaultValue = "", // Default value for uncontrolled usage
  size = "md", // Size variant (e.g., 'sm', 'md', 'lg') for styling
  className = "", // Additional custom classes
  disabled = false, // Disable all options
}) => {
  /* === useState === */
  const [internalValue, setInternalValue] = useState(defaultValue); // Internal state to hold selected value if component is uncontrolled
  /* === End useState === */

  const isControlled = value !== undefined; // Determine if the component is controlled (i.e., `value` prop is passed)

  const currentValue = isControlled ? value : internalValue; // Determine which value to display: controlled or internal

  const handleSelect = (val) => {
    if (!isControlled) {
      setInternalValue(val); // Update internal state only if not controlled
    }

    onChange?.({
      target: {
        name,
        value: val,
      },
    }); // Trigger onChange callback (if provided)
  }; // Function to handle selection of an option

  // Render the button group
  return (
    <div
      className={`select-button-wrapper ${className} ${size} ${
        disabled ? "disabled" : ""
      }`}
    >
      {options.map((opt) => (
        <div
          className={`borderWrapper individual-select-button ${
            currentValue === opt.value ? "selected" : ""
          }`}
          key={opt.value}
        >
          <div className="borderInner">
            <label className={`select-button`}>
              <input
                type="radio"
                name={name}
                value={opt.value}
                checked={currentValue === opt.value}
                onChange={() => handleSelect(opt.value)}
                disabled={disabled}
              />
              {opt.label}
            </label>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SelectButton;
